<!-- <app-welcome *ngIf="showPopup" (close)="closePopup()"></app-welcome> -->

<nav class="main-header">
  <div class="header-container">

    <!-- Logo -->
    <a routerLink="/Home" class="brand">
      <img src="/assets/logo.png" class="logo" alt="Logo" />
    </a>

    <!-- Actions -->
    <div class="header-actions">

      <!-- Search -->
      <button class="icon-btn search-btn" routerLink="/search" aria-label="Search">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="11" cy="11" r="6.5" stroke="#1f1f1f" stroke-width="2"></circle>
          <path d="M16 16L21 21" stroke="#fa9607" stroke-width="2.2" stroke-linecap="round"></path>
        </svg>
      </button>

      <!-- Language -->
      <button class="icon-btn lang-btn" (click)="toggleLanguage()" aria-label="Change language">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="#fa9607" stroke-width="2"></circle>
          <line x1="2" y1="12" x2="22" y2="12" stroke="#fa9607" stroke-width="2" stroke-linecap="round"></line>
          <path d="M12 2A15.3 15.3 0 0 1 12 22A15.3 15.3 0 0 1 12 2Z" stroke="#1f1f1f" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </button>
<!-- Profile -->
<button class="icon-btn profile-btn" routerLink="/Profile" aria-label="Profile">
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="12"
      cy="8"
      r="4"
      stroke="#1f1f1f"
      stroke-width="2"
      stroke-linecap="round"
    ></circle>

    <path
      d="M4 21C4.8 16.8 7.8 14.5 12 14.5C16.2 14.5 19.2 16.8 20 21"
      stroke="#fa9607"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
</button>
    </div>
  </div>
</nav>